/**
 * Service-worker registration with reliable auto-update.
 *
 * registerType is 'autoUpdate' (see vite.config.ts), so a new build's service
 * worker skips waiting and claims open clients. The catch: browsers only *check*
 * for a new worker on navigation, so an already-open tab can sit on a stale build
 * indefinitely. We nudge it — poll for a new worker on an interval and whenever the
 * tab regains focus. When one is found, the autoUpdate flow activates it and reloads.
 *
 * Importing `virtual:pwa-register` here means vite-plugin-pwa's default
 * injectRegister:'auto' will NOT also inject its own registration — this is the one.
 */
import { registerSW } from 'virtual:pwa-register';

const UPDATE_INTERVAL_MS = 60_000;

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;

    const check = () => {
      if (navigator.onLine === false) return;
      if (document.visibilityState !== 'visible') return;
      registration.update().catch(() => {
        /* offline / transient — try again next tick */
      });
    };

    setInterval(check, UPDATE_INTERVAL_MS);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
  },
});
